import type { ReactElement } from 'react';

import { PAYOUT_SUMMARIES_PER_STATUS } from './payout-summaries-per-status';

const DEFAULT_KEY = 'default';
export const getPayoutSummary = (
  status: string,
  symbolKey?: string
): ReactElement | undefined => {
  if (status) {
    const summaries = PAYOUT_SUMMARIES_PER_STATUS[status];
    return summaries?.[symbolKey ?? DEFAULT_KEY] ?? summaries?.[DEFAULT_KEY];
  }
};
